<template>
    <div>
        <v-card flat>
            <v-card-title>
                {{ $t('currencies') }}
                <v-spacer></v-spacer>
                <v-btn 
                    class="mx-1"
                    v-if="selected.currency.length"
                    icon>
                    <v-icon>mdi-eye</v-icon>
                </v-btn>
                <v-btn 
                    class="mx-1"
                    @click="createdDataFetch"
                    icon>
                    <v-icon>mdi-refresh</v-icon>
                </v-btn>
                <v-menu
                    offset-y
                    :close-on-content-click="false"
                    >
                    <template v-slot:activator="{on: menu}">
                        <v-tooltip bottom="">
                            <template v-slot:activator="{on: tooltip}">
                                <v-btn
                                    icon
                                    v-on="{...menu, ...tooltip}"
                                    class="mx-1">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t("search") }}</span>
                        </v-tooltip>
                    </template>
                    <v-text-field
                        :label="$t('search')"
                        solo
                        v-model="search"
                        autofocus="true"
                        @keypress.enter="createdDataFetch"
                        hide-details>
                    </v-text-field>
                </v-menu>
                <v-menu
                    offset-y>
                    <template v-slot:activator="{on}">
                        <v-btn
                            icon
                            v-on="on"
                            class="mx-1">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list width="250" dense>
                        <v-list-item
                            @click="openCurrencyDialog({editMode: false})"
                            link>
                            <v-list-item-icon>
                                <v-icon>mdi-database-plus</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('new_currency') }}</v-list-item-title>
                        </v-list-item>
                        <v-divider v-if="selected.currency.length"></v-divider>
                        <v-list-item
                            v-if="selected.currency.length"
                            link>
                            <v-list-item-icon>
                                <v-icon>mdi-eye</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('show_currency') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            v-if="selected.currency.length"
                            @click="openCurrencyDialog({editMode: true, id: selected.currency[0].id})"
                            link>
                            <v-list-item-icon>
                                <v-icon>mdi-pencil</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('edit_currency') }}</v-list-item-title>
                        </v-list-item>
                         <v-list-item
                            @click="openDeleteSingleDialog({ target: 'currency', id: selected.currency[0].id })"
                            v-if="selected.currency.length"
                            link>
                            <v-list-item-icon>
                                <v-icon>mdi-delete</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('delete_currency') }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-card-title>
            <v-card-text>
                <v-data-table
                    dense
                    show-select
                    v-model="selected.currency"
                    :headers="headers.currency"
                    :items="currencies"
                    @contextmenu:row="open"
                    :loading="loading.data"
                    single-select>
                </v-data-table>
            </v-card-text>
        </v-card>
        <v-menu
            v-model="showMenu"
            :position-x="x"
            :position-y="y"
            absolute
            offset-y
            >
            <v-list width="250" dense>
                <v-list-item
                    v-if="selected.currency.length"
                    link>
                    <v-list-item-icon>
                        <v-icon>mdi-eye</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ $t('show_currency') }}</v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-if="selected.currency.length"
                    @click="openCurrencyDialog({editMode: true, id: selected.currency[0].id})"
                    link>
                    <v-list-item-icon>
                        <v-icon>mdi-pencil</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ $t('edit_currency') }}</v-list-item-title>
                </v-list-item>
                    <v-list-item
                    @click="openDeleteSingleDialog({ target: 'currency', id: selected.currency[0].id })"
                    v-if="selected.currency.length"
                    link>
                    <v-list-item-icon>
                        <v-icon>mdi-delete</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ $t('delete_currency') }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
        <DeleteSingleDialog
            @close="closeDeleteSingleDialog"
            @submit="onDeleteDialogSubmit"
            ref="deleteSingleDialog"/>
        <CurrencyDialog
            v-if="currencyDialogProps.display"
            :id="currencyDialogProps.id"
            @submit="createdDataFetch"
            @close="closeCurrencyDialog"
            ref="currencyDialog"/>
        <SnackbarAlert
            ref="snackbarAlert"/>
    </div>
</template>
<script>
import RetryDialog from '@/components/common/RetryDialog';
import DeleteSingleDialog from '../../components/common/DeleteSingleDialog';
import CurrencyDialog from '@/components/accounting/CurrencyDialog';
import SnackbarAlert from '@/components/common/SnackbarAlert';
import { mapActions, mapState } from 'vuex';
export default {
    name: "Currencies",
    components: {
        RetryDialog,
        DeleteSingleDialog,
        CurrencyDialog,
        SnackbarAlert
    },
    data() {
        return {
            showMenu: false,
            x: 0,
            y: 0,
            selected: {
                currency: []
            },
            headers: {
                currency: [
                    { text: this.$t('code'), value: 'id' },
                    { text: this.$t('currency'), value: 'name' },
                    { text: this.$t('unit_abbreviation'), value: 'abbreviation' },
                    { text: this.$t('symbol'), value: 'symbol' }
                ]
            },
            loading: {
                data: false
            },
            currencyDialogProps: {
                id: null,
                display: false
            },
            deleteSingleDialogProps: {
                id: null,
                display: false,
                target: null,
            },
            options: {},
            search: null
            
        }
    },
    computed: {
        ...mapState('accounting/currency', ["currencies"])
    },
    methods: {
        ...mapActions('accounting/currency', ["fetchCurrencies", "removeCurrency"]),
        ...mapActions('common/snackBar', ["setSnackBars"]),
        async createdDataFetch() {
            try {
                this.loading.data = true;
                await this.fetchCurrencies();
                this.loading.data = false;
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target:"createdDataFetch",message});
            }
        },
        openCurrencyDialog({ editMode, id }) {
            editMode ? this.currencyDialogProps.id = id : this.currencyDialogProps.id = null;
            this.currencyDialogProps.display = true;
            this.selected.currency = [];
        },
        open(e , item) {
            e.preventDefault()
            this.showMenu = false
            this.x = e.clientX
            this.y = e.clientY
            this.$nextTick(() => {
                this.selected.currency = [];
                this.selected.currency.push(item.item);
                this.showMenu = true
            })
        },
        openDeleteSingleDialog(params) {
            // alert('hi');
            // this.deleteSingleDialogProps.id = id;
            // this.deleteSingleDialogProps.target = target;
            // this.deleteSingleDialogProps.display = true;
            this.$refs.deleteSingleDialog.open(params);
            this.selected.currency = [];
        },
		onDeleteDialogSubmit(params) {
            if(params.target == 'currency') {
                this.removeCurrency(params)
                    .then(() => {
                        this.$emit('removeCurrencySuccessfully');
                        this.setSnackBars({color: "success", message: this.$t("records_delete_success")});
                    })
                    .catch((error) => {
                        this.closeDeleteSingleDialog();
                        let message = error.response ? error.response.data.message : error;
                        this.$refs.snackbarAlert.open({color: "error", message});
                    })
            }
        },
        closeDeleteSingleDialog() {
           this.$refs.deleteSingleDialog.close();
        },
        closeCurrencyDialog() {
            this.currencyDialogProps.display = false;
        },
        onRetryDialogSubmit(params){
            if(params.target == "createdDataFetch") {
                if(params.retry) this.createdDataFetch();
            }
        },
        
    },
    created () {
        this.createdDataFetch();
    },
    updated() {
        this.$on('removeCurrencySuccessfully', () => {
            this.closeDeleteSingleDialog();
            this.createdDataFetch();
            
        });
    }
}
</script>